import { motion } from "framer-motion";
import { Rocket, ShoppingBag, CalendarCheck, BookOpenText, MapPin, ArrowUpRight } from "lucide-react";

const services = [
  {
    id: "landing",
    icon: Rocket,
    badge: "Conversion Boost",
    title: "Landing Page ad Alta Conversione",
    description:
      "Design cucito su misura per trasformare utenti in clienti. Velocità fulminea, copywriting strategico e micro-animazioni magnetiche.",
    span: "md:col-span-7",
  },
  {
    id: "ecommerce",
    icon: ShoppingBag,
    badge: "Shopify & Custom",
    title: "E-commerce Moderni",
    description:
      "Store veloci, sicuri, integrati con sistemi di pagamento e ottimizzati per vendere da smartphone.",
    span: "md:col-span-5",
  },
  {
    id: "booking",
    icon: CalendarCheck,
    badge: "Booking 24/7",
    title: "Siti con Prenotazioni Online",
    description:
      "I tuoi clienti prenotano da soli, a qualsiasi ora: appuntamenti, tavoli, consulenze. Tu trovi l'agenda piena.",
    span: "md:col-span-5",
  },
  {
    id: "catalog",
    icon: BookOpenText,
    badge: "QR & Interattivi",
    title: "Menu e Cataloghi Digitali",
    description:
      "Menu, listini e cataloghi prodotti sempre aggiornati, bellissimi da vedere e consultabili da smartphone, anche con QR code.",
    span: "md:col-span-7",
  },
  {
    id: "local",
    icon: MapPin,
    badge: "Local SEO",
    title: "Siti Vetrina & Presenza Online",
    description:
      "Fatti trovare subito su Google e Maps con un sito professionale che sbaraglia la concorrenza, qualunque sia il tuo settore.",
    span: "md:col-span-12",
  },
];

export const Services = () => {
  return (
    <section id="servizi" className="relative py-24 lg:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mb-16 max-w-2xl"
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-cyan-400 mb-4">Servizi</p>
          <h2 className="font-syne text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
            Un sito per ogni attività.{" "}
            <span className="text-zinc-500">Zero template, tutto su misura.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {services.map((s, i) => (
            <motion.div
              key={s.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative col-span-full ${s.span} rounded-2xl border border-white/10 bg-zinc-900/60 backdrop-blur-md p-8 transition-all duration-300 hover:border-cyan-400/40 hover:bg-zinc-900/80 hover:shadow-[0_0_40px_rgba(56,189,248,0.08)]`}
              data-testid={`service-card-${s.id}`}
            >
              <div className="flex items-start justify-between">
                <div className="rounded-xl border border-white/10 bg-zinc-800/60 p-3 text-cyan-400 transition-colors duration-300 group-hover:border-cyan-400/30">
                  <s.icon size={24} />
                </div>
                <span className="rounded-full border border-amber-400/25 bg-amber-400/5 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-amber-300">
                  {s.badge}
                </span>
              </div>
              <h3 className="mt-6 font-syne text-xl sm:text-2xl font-semibold tracking-tight">{s.title}</h3>
              <p className="mt-3 text-zinc-400 leading-relaxed text-sm sm:text-base max-w-xl">{s.description}</p>
              <ArrowUpRight
                size={20}
                className="absolute bottom-6 right-6 text-zinc-600 transition-all duration-300 group-hover:text-cyan-400 group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
